import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_get_inventoryService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { aggregation_level?: string, filters?: $frontendTypes.FootprintApiManager.input_get_inventory, paging?: { top?: number, skip?: number } }): Promise<{ aggregation_level?: string, inventory?: $frontendTypes.FootprintApiManager.public_inventory[], paging?: { total_records?: number, returned_records?: number, top?: number, skip?: number } }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

